import { put } from "redux-saga/effects";

import * as actions from "../actions";
import axiosGovernorate from "../../axios-governorate";
import { setTypehint } from "../actions";

export function* openDialogSaga(action: any) {
  yield put(actions.openDialog(action));
}

export function* closeDialogSaga() {
  yield put(actions.closeDialog());
}

export function* toggleMenuSaga() {
  yield put(actions.toggleMenu());
}

export function* getTypeHintSaga({ searchArea, value }: any) {
  const response = yield axiosGovernorate.post("/api/postAction", {
    action: "typehint",
    searchArea,
    value
  });

  const typeHints = response.data && JSON.parse(response.data);
  yield put(setTypehint(typeHints || null));
}
